// API base for the frontend (2026-10-31 incident fix).
//
// The fallback used to be 'http://localhost:5000/api' in every build. When
// frontend/.env.production stopped being tracked (d0f4e9da8), the server's
// build had no REACT_APP_API_URL and authra.ca called localhost: nobody
// could sign in. Now:
//   REACT_APP_API_URL set (not blank)  that value, trailing slashes removed;
//   unset or blank, development        http://localhost:5000/api;
//   unset or blank, anything else      /api (same origin; nginx proxies it).
//
// The localhost literal sits behind a direct NODE_ENV test, so the
// production bundle drops it (scripts/checkBuild.js fails the build if any
// 'localhost:5000' is left in build/static/js).

const DEV_API_BASE = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : null;

export function resolveApiBase(envUrl, devUrl) {
  const v = String(envUrl || '').trim().replace(/\/+$/, '');
  if (v) return v;
  return devUrl || '/api';
}

// The origin part of an API base: '' for a relative base ('/api' -> '').
export function originOf(apiBase) {
  return String(apiBase || '').replace(/\/api$/, '');
}

export const API_BASE = resolveApiBase(process.env.REACT_APP_API_URL, DEV_API_BASE);

// For server paths outside /api, e.g. a firm logo at /uploads/...
export const API_ORIGIN = originOf(API_BASE);

// A stored file path as an <img> src: absolute URLs as they are, else on API_ORIGIN.
export function serverUrl(p) {
  if (!p) return p;
  return /^https?:\/\//i.test(p) ? p : `${API_ORIGIN}${p}`;
}
